










import { Vue, Component } from 'vue-property-decorator';
import Mapa from '@/pantallas/Peajes/Mapa/Mapa.vue';

@Component({
  components: { Mapa },
})
export default class MapaPantallas extends Vue {}
